import { observer } from "mobx-react";
import { Table, TableBody, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { HeadTable } from "../../../UI/Table";
import InstallmentRowLink from "./InstallmentRowLink";

interface IProps {
  store: any;
  onSelectInstallment: (
    rowId: string,
    installmentId: number,
    checked: boolean
  ) => void;
  notFoundMessage?: { title: string; subtitle: string; trail: string };
}

const InstallmentsTableLink = observer(
  ({ store, onSelectInstallment, notFoundMessage }: IProps) => {
    if (!store.rows.length)
      return (
        <Alert severity="info" style={{ margin: "1rem 0" }}>
          <Typography>{notFoundMessage?.title || ""}</Typography>
          <Typography>
            {notFoundMessage?.subtitle || ""}
            <b>{notFoundMessage?.trail || ""}</b>
          </Typography>
        </Alert>
      );

    return (
      <Table aria-label="collapsible table">
        <HeadTable columns={[...store.columns]} />
        <TableBody>
          {store.rows.map((row: any) => (
            <InstallmentRowLink
              key={row.code}
              columns={store.columns}
              row={row}
              subColumns={store.subColumns}
              onChangeCheck={onSelectInstallment}
            />
          ))}
        </TableBody>
      </Table>
    );
  }
);

export default InstallmentsTableLink;
